@if (variant === 'unified') {
  <!-- Unified Code card (criterion 28): one vertical card for every usage. Only the title and the CTA are
       links; states default / hover / focus-within / muted are styled in styles/unified-code/components/_home.scss.
       R7: the favourite is a toggle button outside the links; `progress` follows the card contract. -->
  <article *ngIf="course" class="uc-card uc-course-card" [class.uc-card--muted]="course.soon" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="uc-card__media">
      <img *ngIf="course.image; else noCourseImage" loading="lazy" [src]="resource + course.image" alt="">
      <ng-template #noCourseImage><span class="uc-card__media-placeholder" aria-hidden="true"><i class="fa-solid fa-graduation-cap"></i></span></ng-template>
      <button *ngIf="isAuthenticated" type="button" class="uc-card__favourite" [class.is-active]="favorite"
        [attr.aria-pressed]="favorite" (click)="toggleFavourite($event)"
        [attr.aria-label]="'course.favouriteToggle' | translate"
        [attr.title]="(favorite ? 'course.removeFromFavourites' : 'course.addToFavourites') | translate">
        <i class="fa-heart" [ngClass]="favorite ? 'fa-solid' : 'fa-regular'" aria-hidden="true"></i>
      </button>
    </div>
    <div class="uc-card__body">
      <div class="uc-card__tags">
        <span *ngIf="courseTypeKey" class="uc-tag uc-tag-primary" [translate]="courseTypeKey"></span>
        <span *ngIf="dateStatus.name && showRegisterStatus" [ngClass]="registrationTagClass" [translate]="'course.status.' + dateStatus.name"></span>
      </div>
      <h3 *ngIf="isRtl ? course.titleAr : course.title" class="uc-card__title uc-text-lg uc-semibold">
        <a *ngIf="course.id; else plainCourseTitle" [routerLink]="['/course/details/' + course.id]">{{ isRtl ? course.titleAr : course.title }}</a>
        <ng-template #plainCourseTitle>{{ isRtl ? course.titleAr : course.title }}</ng-template>
      </h3>
      <ul class="uc-card__meta">
        <li *ngIf="instructorNames">
          <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../../assets/imgs/users.svg)"></span>
          <span class="visually-hidden" translate="unifiedHome.card.instructor"></span>
          <span class="uc-card__meta-value">{{ instructorNames }}</span>
        </li>
        <li *ngIf="course.duration">
          <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../../assets/imgs/hour.svg)"></span>
          <span class="visually-hidden" translate="unifiedHome.card.duration"></span>
          <span class="uc-card__meta-value">{{ course.duration }} <span translate="course.hours"></span></span>
        </li>
        <li *ngIf="course.startDate">
          <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../../assets/imgs/calendar.svg)"></span>
          <span translate="unifiedHome.card.startDate"></span>
          <span class="uc-card__meta-value">{{ course.startDate | date : dateFormat }}</span>
        </li>
      </ul>
      <div class="uc-card__rating">
        <ng-container *ngIf="course.averageRate; else notRated">
          <ngb-rating class="rating" [readonly]="true" [rate]="course.averageRate" [max]="5"
            [attr.aria-label]="'unifiedHome.card.rating' | translate: { rate: course.averageRate }"></ngb-rating>
          <span aria-hidden="true">{{ course.averageRate }}/5</span>
        </ng-container>
        <ng-template #notRated><span translate="unifiedHome.card.notRated"></span></ng-template>
      </div>
      <app-custom-progress *ngIf="shows('progress')" [value]="course.progress"></app-custom-progress>
      <div class="uc-card__footer">
        <div *ngIf="showsPrice" class="uc-card__price">
          <span class="uc-card__price-current uc-text-lg uc-semibold">
            {{ (course.discount ? discountedPrice : course.price) | number : "1.0-1" }} <span translate="course.reyalCurrency"></span>
          </span>
          <s *ngIf="course.discount" class="uc-card__price-old uc-text-sm">
            {{ course.price | number : "1.0-1" }} <span translate="course.reyalCurrency"></span>
          </s>
        </div>
        <div class="uc-card__actions">
          <a *ngIf="course.id" class="btn uc-card__cta" [routerLink]="['/course/details/' + course.id]">
            {{ "unifiedHome.cta.viewCourse" | translate }}
            <span class="visually-hidden">: {{ isRtl ? course.titleAr : course.title }}</span>
          </a>
          <button *ngIf="showsPrice && inCart != null" type="button" class="btn uc-card__cart"
            [class.is-active]="inCart" (click)="addToCart()"
            [attr.aria-label]="(inCart ? 'unifiedHome.card.goToCart' : 'course.addToCart') | translate">
            <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../../assets/imgs/market.svg)"></span>
          </button>
        </div>
      </div>
    </div>
  </article>

  <article *ngIf="path && !course" class="uc-card uc-course-card uc-path-card" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="uc-card__media">
      <img *ngIf="path.image; else noPathImage" loading="lazy" [src]="resource + path.image" alt="">
      <ng-template #noPathImage><span class="uc-card__media-placeholder" aria-hidden="true"><i class="fa-solid fa-route"></i></span></ng-template>
    </div>
    <div class="uc-card__body">
      <div class="uc-card__tags">
        <span class="uc-tag uc-tag-primary" [translate]="path.isDiploma ? 'unifiedHome.card.diploma' : 'unifiedHome.card.learningPath'"></span>
      </div>
      <h3 class="uc-card__title uc-text-lg uc-semibold">
        <a *ngIf="path.id; else plainPathTitle" [routerLink]="['/learning-path/details/' + path.id]">{{ isRtl ? path.nameAr : path.name }}</a>
        <ng-template #plainPathTitle>{{ isRtl ? path.nameAr : path.name }}</ng-template>
      </h3>
      <p *ngIf="isRtl ? path.description : path.descriptionLang" class="uc-card__description uc-text-sm">{{ isRtl ? path.description : path.descriptionLang }}</p>
      <ul class="uc-card__meta">
        <li *ngIf="path.courses">
          <i class="fa-solid fa-graduation-cap uc-card__meta-icon" aria-hidden="true"></i>
          <span [translate]="path.isDiploma ? 'diploma.courseCount' : 'course.courseCount'"></span>
          <span class="uc-card__meta-value">{{ path.courses.length }}</span>
        </li>
        <li *ngIf="path.startDate">
          <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../../assets/imgs/calendar.svg)"></span>
          <span translate="unifiedHome.card.startDate"></span>
          <span class="uc-card__meta-value">{{ path.startDate | date : dateFormat }}</span>
        </li>
        <li *ngIf="path.registerEnd">
          <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../../assets/imgs/calendar.svg)"></span>
          <span translate="unifiedHome.card.registerEnd"></span>
          <span class="uc-card__meta-value">{{ path.registerEnd | date : dateFormat }}</span>
        </li>
      </ul>
      <div class="uc-card__footer">
        <div class="uc-card__actions">
          <a *ngIf="path.id" class="btn uc-card__cta" [routerLink]="['/learning-path/details/' + path.id]">
            {{ "unifiedHome.cta.viewPath" | translate }}
            <span class="visually-hidden">: {{ isRtl ? path.nameAr : path.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </article>
} @else {
<!-- Custom mode (R7): the context's design (see COURSE_CARD_CONTRACT); every fact comes from one shared template below. -->
<article class="course-design-2 border bg-white position-relative" *ngIf="course && variant === 2">
  <div class="course-card-img overflow-hidden" *ngIf="shows('image') && course.image">
    <div class="w-100" [ngStyle]="{ 'background-image': 'url(' + resource + course.image + ')' }"></div>
  </div>
  <ng-container *ngTemplateOutlet="favouriteButton"></ng-container>
  <div class="d-flex flex-column justify-content-between">
    <h5 class="pt-2 pb-1" *ngIf="courseTitle">{{ courseTitle }}</h5>
    <p class="mb-1" *ngIf="shows('description') && courseDescription">{{ courseDescription }}</p>
    <ng-container *ngTemplateOutlet="metaFacts"></ng-container>
    <app-custom-progress *ngIf="shows('progress')" [value]="course.progress"></app-custom-progress>
    <ng-container *ngTemplateOutlet="coursePayment"></ng-container>
    <div class="mt-2 d-flex align-items-center justify-content-between">
      <a class="btn text-white rounded-pill" *ngIf="shows('cta') && course.id"
        [routerLink]="['/course/details/' + course.id]">
        {{ "course.detailsLink" | translate }}<span class="visually-hidden">: {{ courseTitle }}</span>
      </a>
      <div class="d-flex align-items-center">
        <ng-container *ngTemplateOutlet="rating"></ng-container>
        <ng-container *ngTemplateOutlet="instructors"></ng-container>
      </div>
    </div>
  </div>
</article>

<article class="course-design-3 border bg-white" *ngIf="course && variant === 3">
  <div class="course-design-3-header d-flex align-items-center justify-content-between"
    [ngClass]="{ 'mb-3': !shows('progress'), 'mb-2': shows('progress') }">
    <h5 class="mb-0" *ngIf="courseTitle">
      <a *ngIf="course.id; else plainDesign3Title" [routerLink]="['/course/details/' + course.id]">{{ courseTitle }}</a>
      <ng-template #plainDesign3Title>{{ courseTitle }}</ng-template>
    </h5>
    <ng-container *ngTemplateOutlet="typeChip"></ng-container>
  </div>
  <app-custom-progress *ngIf="shows('progress')" [value]="course.progress"></app-custom-progress>
  <!-- The image repeats the title link for pointer users only; the favourite is a sibling over the image. -->
  <div class="course-design-3-media position-relative" [ngClass]="{ 'mt-2': shows('progress') }">
    <a *ngIf="course.image && course.id" class="course-design-3-logo d-block" tabindex="-1" aria-hidden="true"
      [routerLink]="['/course/details/' + course.id]"
      [ngStyle]="{ 'background-image': 'url(' + resource + course.image + ')' }"></a>
    <div *ngIf="course.image && !course.id" class="course-design-3-logo"
      [ngStyle]="{ 'background-image': 'url(' + resource + course.image + ')' }"></div>
    <ng-container *ngTemplateOutlet="favouriteButton; context: { inline: !course.image }"></ng-container>
  </div>
  <ng-container *ngTemplateOutlet="coursePayment"></ng-container>
</article>

<article class="course-design-4 position-relative" *ngIf="course && variant === 4">
  <!-- One favourite button for both faces, outside the flipping card and its links. -->
  <ng-container *ngTemplateOutlet="favouriteButton"></ng-container>
  <div class="border position-relative w-100 bg-white">
    <div class="position-absolute w-100 h-100 d-flex flex-column align-items-center justify-content-between">
      <img loading="lazy" class="w-100" *ngIf="shows('image') && course.image" [src]="resource + course.image" alt="" />
      <ng-container *ngTemplateOutlet="typeChip; context: { overlay: true }"></ng-container>
      <h5 class="mb-0 pb-1" *ngIf="courseTitle">{{ courseTitle }}</h5>
    </div>
    <div class="position-absolute text-center w-100 h-100 d-flex flex-column align-items-center justify-content-between">
      <h5 class="mb-0 pb-1" *ngIf="courseTitle" aria-hidden="true">{{ courseTitle }}</h5>
      <p class="mb-0" *ngIf="shows('description') && courseDescription">{{ courseDescription }}</p>
      <ng-container *ngTemplateOutlet="metaFacts"></ng-container>
      <div class="w-100" *ngIf="shows('progress')">
        <app-custom-progress [value]="course.progress"></app-custom-progress>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <ng-container *ngTemplateOutlet="rating"></ng-container>
        <ng-container *ngTemplateOutlet="instructors"></ng-container>
      </div>
      <div *ngIf="showsPrice" class="border-top w-100">
        <ng-container *ngTemplateOutlet="coursePayment"></ng-container>
      </div>
      <a class="btn text-white rounded-pill w-100 py-2" *ngIf="shows('cta') && course.id"
        [routerLink]="['/course/details/' + course.id]">
        {{ "course.detailsLink" | translate }}<span class="visually-hidden">: {{ courseTitle }}</span>
      </a>
    </div>
  </div>
</article>

<article class="course-design-1 path-details" *ngIf="path && !course" style="min-height: 304px">
  <div class="course-card">
    <div class="course-card-img position-relative w-100" *ngIf="path.image"
      [ngStyle]="{
        'background-image':
          'linear-gradient(0deg, rgba(9, 11, 33, 0.40), rgba(9, 11, 33, 0.40)), url(' + resource + path.image + ')'
      }"></div>
    <div class="course-card-information">
      <div class="course-card-information-type-path position-relative">
        <h5 class="mb-0">{{ isRtl ? path.nameAr : path.name }}</h5>
      </div>
      <div class="course-card-information-details d-flex flex-column justify-content-between">
        <p class="my-1 course-card-information-details-description d-none" *ngIf="path.description">
          {{ isRtl ? path.description : path.descriptionLang }}
        </p>
        <div class="my-1 course-card-information-details-total d-none" *ngIf="path.courses">
          <i class="fa-solid fa-graduation-cap" aria-hidden="true"></i>
          <span [translate]="path.isDiploma ? 'diploma.courseCount' : 'course.courseCount'"></span>
          <span>{{ path.courses.length }}</span>
        </div>
        <div class="my-1 course-card-information-details-calendar d-none" *ngIf="path.registerEnd || path.startDate">
          <div *ngIf="path.registerEnd">
            <i class="fa-solid fa-calendar-days" aria-hidden="true"></i>
            <span translate="course.registerEnd"></span>
            <span>{{ path.registerEnd | date : dateFormat }}</span>
          </div>
          <div *ngIf="path.startDate">
            <i class="fa-solid fa-calendar-days" aria-hidden="true"></i>
            <span translate="course.startDate"></span>
            <span>{{ path.startDate | date : dateFormat }}</span>
          </div>
        </div>
        <a class="mt-2 course-card-information-details-btn btn d-none text-white w-100" *ngIf="path.id"
          [routerLink]="['/learning-path/details/' + path.id]">
          {{ "course.more" | translate }}<span class="visually-hidden">: {{ isRtl ? path.nameAr : path.name }}</span>
          <svg *ngIf="isRtl" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="16" width="30" viewBox="0 0 448 512">
            <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" fill="#fff" />
          </svg>
          <svg *ngIf="!isRtl" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="16" width="30" viewBox="0 0 448 512">
            <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" fill="#FFF" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</article>
}

<!-- ===== Shared fact templates (Custom mode): one rendering per fact ===== -->
<ng-template #favouriteButton let-inline="inline">
  <button *ngIf="isAuthenticated && shows('favourite')" type="button" class="card-favourite btn shadow-none"
    [class.active]="favorite" [class.card-favourite--inline]="inline"
    [attr.aria-pressed]="favorite" (click)="toggleFavourite($event)"
    [attr.aria-label]="'course.favouriteToggle' | translate"
    [attr.title]="(favorite ? 'course.removeFromFavourites' : 'course.addToFavourites') | translate">
    <i class="fa-solid fa-heart" aria-hidden="true"></i>
  </button>
</ng-template>

<ng-template #typeChip let-overlay="overlay">
  <span *ngIf="shows('typeChip') && courseTypeKey" class="course-type-chip rounded-pill"
    [ngClass]="overlay ? [courseTypeClass, 'course-type-chip--overlay'] : courseTypeClass" [translate]="courseTypeKey"></span>
</ng-template>

<ng-template #metaFacts>
  <ul class="card-meta list-unstyled mb-1" *ngIf="(shows('hours') && course.duration) || (shows('startDate') && course.startDate)">
    <li *ngIf="shows('hours') && course.duration">
      <i class="fa-regular fa-clock" aria-hidden="true"></i>
      <span class="visually-hidden" translate="unifiedHome.card.duration"></span>
      <span>{{ course.duration }} <span translate="course.hours"></span></span>
    </li>
    <li *ngIf="shows('startDate') && course.startDate">
      <i class="fa-solid fa-calendar-days" aria-hidden="true"></i>
      <span translate="course.startDate"></span>
      <span>{{ course.startDate | date : dateFormat }}</span>
    </li>
  </ul>
</ng-template>

<ng-template #rating>
  <ngb-rating *ngIf="shows('rating')" class="rating" [readonly]="true" [rate]="course.averageRate || 0" [max]="5"
    [attr.aria-label]="'unifiedHome.card.rating' | translate: { rate: course.averageRate || 0 }"></ngb-rating>
</ng-template>

<ng-template #instructors>
  <div class="course-card-information-details-instructors position-relative overflow-hidden"
    *ngIf="shows('instructor') && course.instructors?.length > 0" [attr.title]="instructorNames">
    <span class="visually-hidden">{{ instructorNames }}</span>
    <ng-container *ngFor="let instructor of course.instructors; let i = index">
      <div class="position-absolute border rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
        [ngStyle]="isRtl ? { right: (i + 1) * 10.8 + 'px', 'z-index': -i } : { left: (i + 1) * 10.8 + 'px', 'z-index': -i }">
        <img loading="lazy" class="w-100" alt=""
          [src]="instructor.instructorImage ? resource + instructor.instructorImage : 'assets/imgs/avatar.jpg'" />
      </div>
    </ng-container>
    <span dir="ltr" aria-hidden="true"
      class="position-relative bg-white border rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
      [ngStyle]="{ 'z-index': course.instructors.length }">{{ "+" + course.instructors.length }}</span>
  </div>
</ng-template>

<ng-template #coursePayment>
  <div class="course-payment w-100" *ngIf="showsPrice">
    <div class="d-flex align-items-center justify-content-between">
      <button *ngIf="inCart != null" type="button" [ngClass]="{ active: inCart }" (click)="addToCart()"
        class="btn shadow-none d-flex align-items-center justify-content-center"
        [attr.aria-label]="(inCart ? 'unifiedHome.card.goToCart' : 'course.addToCart') | translate">
        <span class="icon-mask" aria-hidden="true" style="mask-image: url(./../../../../assets/imgs/market.svg)"></span>
      </button>
      <div class="d-flex align-items-center ms-auto">
        <p *ngIf="course.discount" class="discount">
          <span translate="course.reyalCurrency"></span>
          <span>{{ course.price | number : "1.0-1" }}</span>
        </p>
        <p [class.discount-price]="!!course.discount">
          <span translate="course.reyalCurrency"></span>
          <span>{{ (course.discount ? discountedPrice : course.price) | number : "1.0-1" }}</span>
        </p>
      </div>
    </div>
  </div>
</ng-template>
